<template>
  <div class="d-flex" id="wrapper">
    <div id="sidebar-wrapper">
      <Sidebar :toggler.sync="isToggled"></Sidebar>
      <!-- Page Content -->
    </div>

    <div id="page-content-wrapper">
      <TopNavbar @toggled="toggleSidebarNav"></TopNavbar>
      <div class="card">
        <section class="search-results">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group d-flex">
                <input type="text" class="form-control" placeholder="Search criteria" required />
                <button
                  class="btn btn-success mobile-only"
                  type="button"
                  data-toggle="collapse"
                  data-target="#collapseExample"
                  aria-expanded="false"
                  aria-controls="collapseExample"
                >
                  <i class="fas fa-sliders-h"></i>
                </button>
              </div>
              <div class="collapse" id="collapseExample">
                <ul class="list-unstyled filters">
                  <li>
                    <div class="custom-control custom-checkbox">
                      <input type="checkbox" class="custom-control-input" id="customCheck1" />
                      <label class="custom-control-label" for="customCheck1"
                        >Candidates with best raiting</label
                      >
                    </div>
                  </li>
                  <li>
                    <div class="custom-control custom-checkbox">
                      <input type="checkbox" class="custom-control-input" id="customCheck1" />
                      <label class="custom-control-label" for="customCheck1"
                        >Only unemployed candidates</label
                      >
                    </div>
                  </li>
                  <li>
                    <div class="custom-control custom-checkbox">
                      <input type="checkbox" class="custom-control-input" id="customCheck1" />
                      <label class="custom-control-label" for="customCheck1"
                        >Candidates with full information</label
                      >
                    </div>
                  </li>
                  <li>
                    <div class="custom-control custom-checkbox">
                      <input type="checkbox" class="custom-control-input" id="customCheck1" />
                      <label class="custom-control-label" for="customCheck1"
                        >Unemployed for last six months</label
                      >
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-md-9">
              <h1>Search results for: "Sofia" (15 from 221)</h1>
              <ul class="list-unstyled results">
                <li class="d-flex align-items-center">
                  <span class="type"><i class="fas fa-briefcase"></i></span>
                  <div class="search-result-text">
                    <span class="search-title"><a href="#">Job ad Title search result</a></span>
                    <div class="search-info">
                      <ul class="list-inline">
                        <li class="list-inline-item">
                          <span class="label">Description:</span> Lorem ipsum dolor sit amet,
                          consectetur adipiscing
                        </li>
                        <li class="list-inline-item">
                          <span class="label">Date:</span> 11/18/2020 at 15:44
                        </li>
                        <li class="list-inline-item"><span class="label">Status:</span> Open</li>
                      </ul>
                    </div>
                  </div>
                </li>
                <li class="d-flex align-items-center">
                  <span class="type"><i class="fas fa-city"></i></span>
                  <div class="search-result-text">
                    <span class="search-title"
                      ><a href="#">Comstream Employer based in Sofia</a></span
                    >
                    <div class="search-info">
                      <ul class="list-inline">
                        <li class="list-inline-item">
                          <span class="label">Open positions:</span> 15
                        </li>
                        <li class="list-inline-item"><span class="label">Employees:</span> 100+</li>
                        <li class="list-inline-item">
                          <span class="label">Last Update:</span> 11/18/2020 at 15:44
                        </li>
                      </ul>
                    </div>
                  </div>
                </li>
                <li class="d-flex align-items-center">
                  <span class="type"><i class="fas fa-user"></i></span>
                  <div class="search-result-text">
                    <span class="search-title"><a href="#">Stefan ivanov</a></span>
                    <div class="search-info">
                      <ul class="list-inline">
                        <li class="list-inline-item">
                          <span class="label">Email:</span> ap@jobshark.eu
                        </li>
                        <li class="list-inline-item">
                          <span class="label">Country:</span> Bulgaria
                        </li>
                        <li class="list-inline-item"><span class="label">City:</span> Sofia</li>
                        <li class="list-inline-item">
                          <span class="label">Status:</span> Employed
                        </li>
                      </ul>
                    </div>
                  </div>
                </li>
                <li class="d-flex align-items-center">
                  <span class="type"><i class="fas fa-file-pdf"></i></span>
                  <div class="search-result-text">
                    <span class="search-title"><a href="#">Primary CV - Stefan</a></span>
                    <div class="search-info">
                      <ul class="list-inline">
                        <li class="list-inline-item">
                          <span class="label">Upload Date:</span> 11/18/2020 at 15:44
                        </li>
                      </ul>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="col-md-3 desktop-only">
              <span class="title">Filters</span>
              <ul class="list-unstyled filters">
                <li>
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" id="customCheck22" />
                    <label class="custom-control-label" for="customCheck22"
                      >Candidates with best raiting</label
                    >
                  </div>
                </li>
                <li>
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" id="customCheck1" />
                    <label class="custom-control-label" for="customCheck1"
                      >Only unemployed candidates</label
                    >
                  </div>
                </li>
                <li>
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" id="customCheck1" />
                    <label class="custom-control-label" for="customCheck1"
                      >Candidates with full information</label
                    >
                  </div>
                </li>
                <li>
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" id="customCheck1" />
                    <label class="custom-control-label" for="customCheck1"
                      >Unemployed for last six months</label
                    >
                  </div>
                </li>
              </ul>
              <ul class="list-unstyled filters">
                <li>
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" id="customCheck1" />
                    <label class="custom-control-label" for="customCheck1"
                      >Newest job positions</label
                    >
                  </div>
                </li>
                <li>
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" id="customCheck1" />
                    <label class="custom-control-label" for="customCheck1"
                      >Only opened job positions</label
                    >
                  </div>
                </li>
                <li>
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" id="customCheck1" />
                    <label class="custom-control-label" for="customCheck1"
                      >Closed job positions</label
                    >
                  </div>
                </li>
              </ul>
              <ul class="list-unstyled filters">
                <li>
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" id="customCheck1" />
                    <label class="custom-control-label" for="customCheck1"
                      >Employers with higher raiting</label
                    >
                  </div>
                </li>
                <li>
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" id="customCheck1" />
                    <label class="custom-control-label" for="customCheck1">New Employers</label>
                  </div>
                </li>
                <li>
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" id="customCheck1" />
                    <label class="custom-control-label" for="customCheck1"
                      >Employers with most open positions</label
                    >
                  </div>
                </li>
                <li>
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" id="customCheck1" />
                    <label class="custom-control-label" for="customCheck1"
                      >Check this custom checkbox</label
                    >
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </section>
      </div>
      <!-- End page-content-wrapper -->
    </div>
  </div>
</template>

<script>
import Sidebar from '@/components/Navigations/Sidebar';
import TopNavbar from '@/components/Navigations/TopNavbar';

export default {
  components: {
    Sidebar,
    TopNavbar,
  },
  data: () => ({ isToggled: false }),
  methods: {
    toggleSidebarNav() {
      this.isToggled = !this.isToggled;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';
.card {
  min-height: 860px;
  padding-top: 8px;
  h1 {
    font-size: 21px;
    margin: 20px 0 12px 0;
  }
}
.search-results {
  padding: 12px 20px;
  .form-group {
    font-family: $font-family-sans-lato;
    position: relative;
    width: 75%;
    .form-control {
      box-shadow: none !important;
    }
    .custom-select {
      position: absolute;
      top: 0px;
      left: -4px;
      width: 18%;
      box-shadow: none !important;
      border: none !important;
      border-right: 1px solid #ddd !important;
    }
  }
  .list-unstyled.results {
    li {
      padding: 12px 0;
      border-bottom: 1px solid #ddd;
      .type {
        width: 42px;
        height: 42px;
        background: #ccc;
        border-radius: 50%;
        margin-right: 12px;
        text-align: center;
        font-size: 21px;
        line-height: 42px;
        color: #fff;
        flex-shrink: 0;
      }
      .search-result-text {
        font-family: $font-family-sans-lato;
        .search-title {
          font-weight: 700;
          display: block;
          margin-bottom: 6px;
          a {
            text-decoration: none;
          }
        }
        .search-info {
          font-size: 14px;
          .list-inline {
            margin-bottom: 0;
            li {
              margin-right: 15px;
              padding: 0;
              border: none;
              .label {
                font-weight: 600;
              }
            }
          }
        }
      }
    }
  }
  .col-md-3 .title {
    font-size: 21px;
    margin: 16px 0 12px 0;
    display: block;
  }
  .list-unstyled.filters {
    font-family: $font-family-sans-lato;
    margin-bottom: 20px;
    li {
      margin-bottom: 8px;
    }
  }
}

.mobile-only {
  display: none;
}

@media only screen and (max-width: 1251px) {
  .card {
    margin: 24px 23px 0 23px !important;
  }
}

@media only screen and (max-width: 992px) {
  .card {
    margin: 24px 0px 0 0px !important;
  }
  .search-results {
    padding: 12px 20px;
    .form-group {
      font-family: $font-family-sans-lato;
      position: relative;
      flex-wrap: wrap;
      width: 100%;
      .form-control {
        box-shadow: none !important;
        padding-left: 15px;
        margin-bottom: 12px;
      }
      .custom-select {
        position: relative;
        top: 0px;
        left: 0px;
        flex: 1;
        box-shadow: none !important;
        border: 1px solid #ddd !important;
      }
      .btn-success {
        margin: 0 0 0 12px;
      }
    }
    .list-unstyled.results {
      li {
        padding: 12px 0;
        border-bottom: 1px solid #ddd;
        .type {
          width: 42px;
          height: 42px;
          background: #ccc;
          border-radius: 50%;
          margin-right: 12px;
          text-align: center;
          font-size: 21px;
          line-height: 42px;
          color: #fff;
          flex-shrink: 0;
        }
        .search-result-text {
          font-family: $font-family-sans-lato;
          .search-title {
            font-weight: 700;
            display: block;
            margin-bottom: 6px;
            a {
              text-decoration: none;
            }
          }
          .search-info {
            font-size: 14px;
            .list-inline {
              margin-bottom: 0;
              li {
                margin-right: 15px;
                padding: 0;
                border: none;
                .label {
                  font-weight: 600;
                }
              }
            }
          }
        }
      }
    }
    .col-md-3 .title {
      font-size: 21px;
      margin: 16px 0 12px 0;
      display: block;
    }
    .list-unstyled.filters {
      font-family: $font-family-sans-lato;
      margin-bottom: 20px;
      li {
        margin-bottom: 8px;
      }
    }
  }
  .desktop-only {
    display: none;
  }
  .mobile-only {
    display: inline-block;
  }
}

@media only screen and (max-width: 768px) {
  .search-results {
    padding: 12px 20px;
    .form-group {
      font-family: $font-family-sans-lato;
      position: relative;
      flex-wrap: wrap;
      .form-control {
        box-shadow: none !important;
        padding-left: 15px;
        margin-bottom: 0px;
      }
      .custom-select {
        position: relative;
        top: 0px;
        left: 0px;
        flex: 1;
        box-shadow: none !important;
        border: 1px solid #ddd !important;
        margin-top: 12px;
      }
      .btn-success {
        margin: 12px 0 0 12px;
      }
    }
    .list-unstyled.results {
      li {
        padding: 12px 0;
        border-bottom: 1px solid #ddd;
        .type {
          width: 42px;
          height: 42px;
          background: #ccc;
          border-radius: 50%;
          margin-right: 12px;
          text-align: center;
          font-size: 21px;
          line-height: 42px;
          color: #fff;
          flex-shrink: 0;
        }
        .search-result-text {
          font-family: $font-family-sans-lato;
          .search-title {
            font-weight: 700;
            display: block;
            margin-bottom: 6px;
            a {
              text-decoration: none;
            }
          }
          .search-info {
            font-size: 14px;
            .list-inline {
              margin-bottom: 0;
              li {
                margin-right: 15px;
                padding: 0;
                border: none;
                .label {
                  font-weight: 600;
                }
              }
            }
          }
        }
      }
    }
    .col-md-3 .title {
      font-size: 21px;
      margin: 16px 0 12px 0;
      display: block;
    }
    .list-unstyled.filters {
      font-family: $font-family-sans-lato;
      margin-bottom: 20px;
      li {
        margin-bottom: 8px;
      }
    }
  }
  .desktop-only {
    display: none;
  }
  .mobile-only {
    display: inline-block;
  }
}

@media only screen and (max-width: 576px) {
  .card {
    margin-top: 0 !important;
    border-top-left-radius: 18px !important;
    border-top-right-radius: 18px !important;
  }
  .search-results {
    padding: 12px 20px;
    .form-group.d-flex {
      font-family: $font-family-sans-lato;
      position: relative;
      flex-wrap: nowrap;
      .form-control {
        box-shadow: none !important;
        padding-left: 15px;
        margin-bottom: 0px;
        width: 100%;
      }
      .custom-select {
        position: relative;
        top: 0px;
        left: 0px;
        flex: 1;
        box-shadow: none !important;
        border: 1px solid #ddd !important;
        margin-top: 12px;
      }
      .btn-success {
        align-items: flex-start;
        margin: 0px 0 0 12px !important;
      }
    }
    .list-unstyled.results {
      li {
        padding: 12px 0;
        border-bottom: 1px solid #ddd;
        .type {
          width: 42px;
          height: 42px;
          background: #ccc;
          border-radius: 50%;
          margin-right: 12px;
          text-align: center;
          font-size: 21px;
          line-height: 42px;
          color: #fff;
          flex-shrink: 0;
        }
        .search-result-text {
          font-family: $font-family-sans-lato;
          .search-title {
            font-weight: 700;
            display: block;
            margin-bottom: 6px;
            a {
              text-decoration: none;
            }
          }
          .search-info {
            font-size: 14px;
            .list-inline {
              margin-bottom: 0;
              li {
                margin-right: 15px;
                padding: 0;
                border: none;
                .label {
                  font-weight: 600;
                }
              }
            }
          }
        }
      }
    }
    .col-md-3 .title {
      font-size: 21px;
      margin: 16px 0 12px 0;
      display: block;
    }
    .list-unstyled.filters {
      font-family: $font-family-sans-lato;
      margin-bottom: 20px;
      li {
        margin-bottom: 8px;
      }
    }
  }
  .desktop-only {
    display: none;
  }
  .mobile-only {
    display: inline-block;
  }
}
</style>
